import { LanguageEntries } from './LanguageEntries';
import { LanguageContext } from './LanguageContext';

const translator = (key: keyof LanguageEntries): string => {
  const lng: LanguageEntries = {
    no: 'Nein',
    yes: 'Ja',
    close: 'Schließen',
    german: 'Deutsch',
    english: 'Englisch',
    selectLanguage: 'Sprache wählen...',
    pleaseSelect: 'Bitte wählen...',
    mr: 'Herr',
    mrs: 'Frau',
    clear: 'Leeren',
    cancel: 'Abbr.',
    yesUsCitizen: 'Ja, US-Bürger',
    noUsCitizen: 'Nein, kein US-Bürger',
    fatcaInfo: `
    <p>Ich bin keine US Person - Aufgrund der FATCA-Bestimmungen (Foreign Account Tax Compliance Act) muss bei der 
    Kontoeröffnung festgestellt werden, ob Sie möglicherweise in den USA steuerpflichtig sind.</p>
<p>US Person ist definiert als</p>
<ol>
<li>US-Staatsbürger (auch doppelte Staatsbürgerschaft)</li> 
<li>Wohnsitz in den USA 
(US resident alien, z.B. Greencard oder substantial presence, Details siehe 
<a href="https://www.irs.gov/individuals/international-taxpayers/determining-alien-tax-status">
https://www.irs.gov/individuals/international-taxpayers/determining-alien-tax-status
</a>) </li>
<li>in den USA / auf US-Territorium geboren</li> 
<li>Aus einem anderen Grund in den USA steuerpflichtig (z.B. 
Doppelwohnsitz, gemeinsame Steuererklärung mit US-Person etc.)
</li>
</ol>
`,

    missing: 'Fehlt',
    expiryError: 'Das Ausweisdokument muss noch mindestens drei Monate gültig sein',
    expiryInfo: '<p>Das Ausweisdokument muss noch mindestens drei Monate ab dem heutigen Tage gültig sein.</p>',
    invalidNumber: 'Ungültige Zahl',
    invalidDate: 'Ungültiges Datum',
    confirm: 'Bestätigen',

    disclosureTitle: 'Persönliche Angaben',
    disclosureWelcomeText: 'Für die Abwicklung Ihres Vertrages benötigen wir noch einige wenige Angaben:',

    disclosureSuccessTitle: 'Vielen Dank! Ihre Daten wurden sicher übertragen.',
    disclosureSuccessText:
      '<p>Wir sind fast fertig!<br/><br/>' +
      'Als letzten Schritt benötigen wir noch Ihre Legitimation. Bitte folgen Sie hierzu den Angaben in der Email.</p>',

    title: 'Anrede',
    name: 'Name',
    firstName: 'Vorname',
    lastName: 'Nachname',
    street: 'Straße',
    housenumber: ' Hausnummer',
    zipCode: 'PLZ',
    city: 'Stadt',
    partner1RegisterAddress: 'Meldeanschrift Land',
    mail: 'Mailadresse',
    phonenumber: 'Telefonnummer',
    partner1MaritalStatus: 'Familienstand',
    partner1Nationality: 'Staatsangehörigkeit',
    partner1CountryOfBirth: 'Geburtsland',
    disclosureHeaderPersonalData: 'Meldedaten Vertragspartner',
    germany: 'Deutschland',
    notGermany: 'Nicht Deutschland',
    partner1NoUSCitizen: 'Bestätigung US-Bürger',

    maritalSingle: 'Ledig',
    maritalMarried: 'Verheiratet',
    maritalParted: 'Getrennt',
    maritalWidowed: 'Verwitwet',
    maritalDivorced: 'Geschieden',
    maritalDivorcedNoAlimony: 'Geschieden (keine bestehenden Unterhaltspflichten)',
    maritalPartnership: 'Lebensgemeinschaft',
    maritalRegisteredLifePartnership: 'Eingetragene Lebenspartnerschaft',

    identityCardDataTitle: 'Ausweisdaten Vertragspartner',
    identityCardType: 'Ausweisart',
    identityCardNumber: 'Ausweisnummer',
    identityCardPlaceOfIssue: 'Ort der Ausstellung',
    identityCardIssueAgency: 'Ausstellungsbehörde',
    identityCardDateOfIssue: 'Datum der Ausstellung',
    identityCardDateOfExpire: 'Ablauffrist',
    dateOfBirth: 'Geburtsdatum',
    placeOfBirth: 'Geburtsort',
    cardTypeGermanIdentityCard: 'Deutscher Personalausweis',
    cardTypeGermanPassport: 'Deutscher Reisepass',
    cardTypeEUIdentityCard: 'EU-Personalausweis',
    cardTypeEUPassport: 'EU-Reisepass',
    cardTypeOtherPassport: 'Andere Reisepässe',

    budgetTitle: 'Haushalt',
    budgetAlimonyPersonCount: 'Anzahl aller im Haushalt lebenden Personen',
    budgetAlimonyChildrenCount: 'Davon Kinder',
    budgetJobType: 'Beruf',
    budgetProbationaryPeriod: 'In der Probezeit',
    budgetFixedTermEmploymentContract: 'Befristeter Arbeitsvertrag',
    budgetEmploymentContractEndStamp: 'Datum der Befristung',
    budgetNetIncome: 'Einkünfte aus nichtselbstständiger Arbeit pro Monat',
    budgetAdditionalIncome: 'Sonstige Einkünfte pro Monat',
    budgetQualityQuestion1: 'Ich versichere, dass die Geldüberlassung für den privaten Konsum bestimmt ist.',
    budgetQualityQuestion2:
      'Ich versichere, dass gegen mich weder ein Insolvenzverfahren eröffnet wurde, noch ' +
      'Zwangsvollstreckungsmaßnahmen wie z.B. Sachpfändungen, Lohn- und Gehaltspfändungen ergriffen wurden und d' +
      'as ich keine Vermögensauskunft (eidesstattliche Versicherung) über die wirtschaftlichen Verhältnisse abgegeb' +
      'en habe.',
    budgetQualityQuestion3: 'Ich versichere, dass alle Angaben vollständig und wahrheitsgemäß gemacht wurden.',
    jobTypeEmployee: 'Angestellter',
    jobTypeWorker: 'Arbeiter',
    jobTypeFreelancer: 'Freiberuflich tätig',
    jobTypeSelfEmployed: 'Selbständig tätig',
    jobTypeClerk: 'Beamter',
    jobTypePensioner: 'Rentner',
    jobTypeUnemployed: 'Arbeitslos',
    jobTypePupil: 'Schüler',
    jobTypeStudent: 'Student',
    jobTypeApprentice: 'Auszubildender',
    jobTypeAtHome: 'Hausfrau/-mann',
    jobTypeWithoutJob: 'Nicht berufstätig',
    jobTypeIndependent: 'Privatier',

    bankSectionTitle: 'Ihre Bankdaten für die Auszahlung',
    bankAccountOwner: 'Kontoinhaber',
    iban: 'IBAN',

    euCountryBelgium: 'Belgien',
    euCountryBulgaria: 'Bulgarien',
    euCountryDenmark: 'Dänemark',
    euCountryGermany: 'Deutschland',
    euCountryEstonia: 'Estland',
    euCountryFinland: 'Finnland',
    euCountryFrance: 'Frankreich',
    euCountryGreece: 'Griechenland',
    euCountryNetherlands: 'Niederlande',
    euCountryItaly: 'Italien',
    euCountryIreland: 'Irland',
    euCountryCroatia: 'Kroatien ',
    euCountryLatvia: 'Lettland',
    euCountryLithuania: 'Litauen',
    euCountryLuxembourg: 'Luxemburg',
    euCountryMalta: 'Malta',
    euCountryAustria: 'Österreich',
    euCountryPoland: 'Polen',
    euCountryPortugal: 'Portugal',
    euCountryRomania: 'Rumänien',
    euCountrySweden: 'Schweden',
    euCountrySlovakia: 'Slowakei',
    euCountrySlovenia: 'Slowenien',
    euCountrySpain: 'Spanien ',
    euCountryCzech: 'Republic Tschechien',
    euCountryHungary: 'Ungarn ',
    euCountryCyprus: 'Zypern',

    error: 'Fehler',

    unknownLoadError: 'Die Daten konnten nicht geladen werden. Bitte versuchen Sie es später noch einmal!',
    forbiddenLoadError: 'Die von Ihnen angeforderte Selbstauskunft ist bereits ausgefüllt worden.',
    notFoundLoadError: 'Die von Ihnen angeforderte Selbstauskunft konnte nicht gefunden werden',
    submitErrorDialogTitle: 'Übertragungsfehler',
    submitErrorDialogText: 'Die Daten konnten nicht übermittelt werden. Bitte versuchen Sie es später noch einmal.',

    errorPleaseContact: 'Bitte wenden Sie sich an den fintechOne-Kundenservice',
    contactCustomerService: 'Kundenservice-Center',
    contactSupportNumber: '0800 800 00 12',
    contactCallbackService: 'Kontakt/Rückrufservice',
    contactSupportChat: 'Beraterchat',
    contactMailAddress: 'info@fintechOne.de',
    contactCompanyName: 'fintechOne mobility GmbH',
    contactAddress: 'Würmstrasse 55',
    contactZipCodeCity: '82166 München-Gräfelfing',
    contactCountry: 'Deutschland',

    disclosureSubmitButtonText: 'Persönliche Daten übermitteln',
    inspectionPageTitle: 'Zusatzinformationen',
    inspectionWelcomeTextHuesges:
      '<p>Sehr geehrter Kunde,</p>\n' +
      '      <p>\n' +
      '        Sie haben sich für die Variante einer Gutachtenerstellung bei Ihnen Zuhause oder an einem Ort Ihrer Wahl und\n' +
      '        somit für eine zeit- und kostensparende Lösung entschieden. Fahrten zu Prüfstationen oder entfernten\n' +
      '        Niederlassungen sind nicht mehr notwendig, wir kommen zu Ihnen!\n' +
      '      </p>\n' +
      '      <p>\n' +
      '        Bitte geben Sie untenstehend Ihre Kontaktdaten ein, damit der KFZ-Gutachter Sie anrufen und einen Termin mit\n' +
      '        Ihnen vereinbaren kann:\n' +
      '      </p>',
    inspectionContactDataTitle: 'Kontaktdaten',
    inspectionVehicleDataTitle: 'Fahrzeugdaten',
    inspectionVehicleFinLabel: 'FIN',
    inspectionVehicleLicensePlateLabel: 'Kennzeichen',
    inspectionVehicleManufacturerLabel: 'Hersteller',
    inspectionVehicleModelLabel: 'Modell',
    inspectionVehicleMileage: 'Laufleistung',
    inspectionVehicleRegistrationDate: 'Erstzulassung',
    inspectionAlternativeTitle: 'Abweichender Besichtigungsort',

    inspectionSuccessTitle: 'Erfolgreich beantragt',
    inspectionSuccessText: `<p>Sehr geehrter Kunde,</p>
<p>Vielen Dank.</p>
<p>
  Ihr Gutachter wird sich mit Ihnen in Verbindung setzen.<br />
  <br />
  Wir freuen uns auf die Zusammenarbeit.<br />
  <br />
  Mit besten Grüßen,<br />
  <br />
  Team Kundenservice<br />
</p>

<p>
<strong>Tipp:</strong>&nbsp;Ihr Fahrzeug macht innen und außen frisch gereinigt den besten Eindruck!
</p>
`,

    inspectionLoadNotFoundError: 'Die Daten konnten nicht geladen werden. Bitte versuchen Sie es später noch einmal!',
    inspectionLoadForbiddenError: 'Die von Ihnen angeforderte Gutachten-Anfrage ist bereits ausgefüllt worden.',
    inspectionLoadUnknownError: 'Die von Ihnen angeforderte Gutachten-Anfrage konnte nicht gefunden werden',
    inspectionVehicleRegistrationDateTooOld: 'Die Erstzulassung ist zu lange her.',
    inspectionVehicleMileageTooHigh: 'Die maximale Laufleistung ist bereits erreicht',

    countryDE: 'Deutschland',
    countryFR: 'Frankreich',
    countryNL: 'Niederlande',
    countryIT: 'Italien',
    countryIE: 'Irland',
    countryDK: 'Dänemark',
    countryGR: 'Griechenland',
    countryPT: 'Portugal',
    countryES: 'Spanien',
    countryBE: 'Belgien',
    countryLU: 'Luxemburg',
    countryIS: 'Island',
    countryNO: 'Norwegen',
    countrySE: 'Schweden',
    countryFI: 'Finnland',
    countryLI: 'Liechtenstein',
    countryAT: 'Österreich',
    countryCH: 'Schweiz (Confoederatio Helvetica)',
    countryFO: 'Färöer',
    countryAD: 'Andorra',
    countryGI: 'Gibraltar',
    countryVA: 'Vatikanstadt',
    countryMT: 'Malta',
    countrySM: 'San Marino',
    countryTR: 'Türkei',
    countryEE: 'Estland',
    countryLV: 'Lettland',
    countryLT: 'Litauen',
    countryPL: 'Polen',
    countryCZ: 'Tschechien',
    countrySK: 'Slowakei',
    countryHU: 'Ungarn',
    countryRO: 'Rumänien',
    countryBG: 'Bulgarien',
    countryAL: 'Albanien',
    countryUA: 'Ukraine',
    countryBY: 'Belarus (Weißrussland)',
    countryMD: 'Moldawien (Republik Moldau)',
    countryRU: 'Russische Föderation',
    countryGE: 'Georgien',
    countryAM: 'Armenien',
    countryAZ: 'Aserbaidschan',
    countryKZ: 'Kasachstan',
    countryTM: 'Turkmenistan',
    countryUZ: 'Usbekistan',
    countryTJ: 'Tadschikistan',
    countryKG: 'Kirgisistan',
    countrySI: 'Slowenien',
    countryHR: 'Kroatien',
    countryBA: 'Bosnien und Herzegowina',
    countryMK: 'Mazedonien',
    countryME: 'Montenegro',
    countryRS: 'Serbien',
    countryU1: 'Großbritannien',
    countryGG: 'Guernsey (Kanalinsel)',
    countryJE: 'Jersey (Kanalinsel)',
    countryIM: 'Insel Man',
    countryMA: 'Marokko',
    countryDZ: 'Algerien',
    countryTN: 'Tunesien',
    countryLY: 'Libyen',
    countryEG: 'Ägypten',
    countrySD: 'Sudan',
    countrySS: 'Südsudan',
    countryMR: 'Mauretanien',
    countryML: 'Mali',
    countryBF: 'Burkina Faso',
    countryNE: 'Niger',
    countryTD: 'Tschad',
    countryCV: 'Kap Verde',
    countrySN: 'Senegal',
    countryGM: 'Gambia',
    countryGW: 'Guinea-Bissau',
    countryGN: 'Guinea',
    countrySL: 'Sierra Leone',
    countryLR: 'Liberia',
    countryCI: 'Côte d’Ivoire (Elfenbeinküste)',
    countryGH: 'Ghana',
    countryTG: 'Togo',
    countryBJ: 'Benin',
    countryNG: 'Nigeria',
    countryCM: 'Kamerun',
    countryCF: 'Zentralafrikanische Republik',
    countryGQ: 'Äquatorialguinea',
    countryST: 'São Tomé und Príncipe',
    countryGA: 'Gabun',
    countryCG: 'Kongo, Republik (ehem. K.-Brazzaville)',
    countryCD: 'Kongo, Demokratische Republik (ehem. Zaire)',
    countryRW: 'Ruanda',
    countryBI: 'Burundi',
    countrySH: 'St. Helena',
    countryAO: 'Angola',
    countryET: 'Äthiopien',
    countryER: 'Eritrea',
    countryDJ: 'Dschibuti',
    countrySO: 'Somalia',
    countryKE: 'Kenia',
    countryUG: 'Uganda',
    countryTZ: 'Tansania, Vereinigte Republik',
    countrySC: 'Seychellen',
    countryIO: 'Britisches Territorium im Indischen Ozean',
    countryMZ: 'Mosambik',
    countryMG: 'Madagaskar',
    countryMU: 'Mauritius',
    countryKM: 'Komoren',
    countryYT: 'Mayotte',
    countryZM: 'Sambia',
    countryMW: 'Malawi',
    countryZA: 'Südafrika',
    countryNA: 'Namibia',
    countryBW: 'Botswana',
    countrySZ: 'Swasiland',
    countryLS: 'Lesotho',
    countryUS: 'Vereinigte Staaten von Amerika',
    countryCA: 'Kanada',
    countryGL: 'Grönland',
    countryPM: 'Saint-Pierre und Miquelon',
    countryMX: 'Mexiko',
    countryBM: 'Bermuda',
    countryGT: 'Guatemala',
    countryBZ: 'Belize',
    countryHN: 'Honduras',
    countrySV: 'El Salvador',
    countryNI: 'Nicaragua',
    countryCR: 'Costa Rica',
    countryPA: 'Panama',
    countryAI: 'Anguilla',
    countryCU: 'Kuba',
    countryKN: 'St. Kitts und Nevis',
    countryHT: 'Haiti',
    countryBS: 'Bahamas',
    countryTC: 'Turks- und Caicosinseln',
    countryDO: 'Dominikanische Republik',
    countryVI: 'Amerikanische Jungferninseln',
    countryAG: 'Antigua und Barbuda',
    countryDM: 'Dominica',
    countryKY: 'Kaimaninseln',
    countryJM: 'Jamaika',
    countryLC: 'St. Lucia',
    countryVC: 'St. Vincent und die Grenadinen',
    countryVG: 'Britische Jungferninseln',
    countryBB: 'Barbados',
    countryMS: 'Montserrat',
    countryTT: 'Trinidad und Tobago',
    countryGD: 'Grenada',
    countryAW: 'Aruba',
    countryBQ: 'Bonaire, Sint Eustatius und Saba (Niederlande)',
    countryCW: 'Curaçao',
    countrySX: 'Sint Maarten (niederl. Teil)',
    countryCO: 'Kolumbien',
    countryVE: 'Venezuela',
    countryGY: 'Guyana',
    countrySR: 'Suriname',
    countryEC: 'Ecuador',
    countryPE: 'Peru',
    countryBR: 'Brasilien',
    countryCL: 'Chile',
    countryBO: 'Bolivien',
    countryPY: 'Paraguay',
    countryUY: 'Uruguay',
    countryAR: 'Argentinien',
    countryFK: 'Falklandinseln',
    countryCY: 'Zypern',
    countryLB: 'Libanon',
    countrySY: 'Syrien, Arabische Republik',
    countryIQ: 'Irak',
    countryIR: 'Iran, Islamische Republik',
    countryIL: 'Israel',
    countryPS: 'Staat Palästina',
    countryTL: 'Osttimor (Timor-Leste)',
    countryJO: 'Jordanien',
    countrySA: 'Saudi-Arabien',
    countryKW: 'Kuwait',
    countryBH: 'Bahrain',
    countryQA: 'Katar',
    countryAE: 'Vereinigte Arabische Emirate',
    countryOM: 'Oman',
    countryYE: 'Jemen',
    countryAF: 'Afghanistan',
    countryPK: 'Pakistan',
    countryIN: 'Indien',
    countryBD: 'Bangladesch',
    countryMV: 'Malediven',
    countryLK: 'Sri Lanka',
    countryNP: 'Nepal',
    countryBT: 'Bhutan',
    countryMM: 'Myanmar (Burma)',
    countryTH: 'Thailand',
    countryLA: 'Laos, Demokratische Volksrepublik',
    countryVN: 'Vietnam',
    countryKH: 'Kambodscha',
    countryID: 'Indonesien',
    countryMY: 'Malaysia',
    countryBN: 'Brunei Darussalam',
    countrySG: 'Singapur',
    countryPH: 'Philippinen',
    countryMN: 'Mongolei',
    countryCN: 'China, Volksrepublik',
    countryKP: 'Korea, Demokratische Volksrepublik (Nordkorea)',
    countryKR: 'Korea, Republik (Südkorea)',
    countryJP: 'Japan',
    countryTW: 'Republik China (Taiwan)',
    countryHK: 'Hongkong',
    countryMO: 'Macau',
    countryAU: 'Australien',
    countryPG: 'Papua-Neuguinea',
    countryNR: 'Nauru',
    countryNZ: 'Neuseeland',
    countrySB: 'Salomonen',
    countryTV: 'Tuvalu',
    countryNC: 'Neukaledonien',
    countryWF: 'Wallis und Futuna',
    countryKI: 'Kiribati',
    countryPN: 'Pitcairninseln',
    countryFJ: 'Fidschi',
    countryVU: 'Vanuatu',
    countryTO: 'Tonga',
    countryWS: 'Samoa',
    countryMP: 'Nördliche Marianen',
    countryPF: 'Französisch-Polynesien',
    countryFM: 'Mikronesien',
    countryMH: 'Marshallinseln',
    countryPW: 'Palau',
    countryAS: 'Amerikanisch-Samoa',
    countryGU: 'Guam',
    countryUM: 'United States Minor Outlying Islands',
    countryCC: 'Kokosinseln',
    countryCX: 'Weihnachtsinsel',
    countryHM: 'Heard und McDonaldinseln',
    countryNF: 'Norfolkinsel',
    countryCK: 'Cookinseln',
    countryNU: 'Niue',
    countryTK: 'Tokelau',
    countryAQ: 'Antarktika',
    countryBV: 'Bouvetinsel',
    countryGS: 'Südgeorgien und die Südlichen Sandwichinseln',
    countryTF: 'Französische Süd- und Antarktisgebiete',
  };
  const value = lng[key];
  return value == null ? '[' + key + ']' : value;
};

export const germanLanguage: LanguageContext = {
  language: 'de',
  translate: translator,
};



// WEBPACK FOOTER //
// ./src/shared/language/German.tsx